import React, { useEffect, useRef, useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Personalization from './PersonalizationDiy';
import ActionButton from './ActionButtonDiy';
import GroupActionButton from './GroupActionButton';
import Branching from './BranchingDiy';
import Logo from './logo';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as styles from './Diy.module.css';

const PersonalizationInfo = ({
  video,
  playerRef,
  defaultPersonalizationInfo,
}) => {
  const formRef = useRef();
  const [formData, setFormData] = useState(defaultPersonalizationInfo);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const renderFormControls = interactivity => {
    switch (interactivity) {
      case 'Personalization':
        return (
          <Personalization
            formData={formData}
            handleInputChange={handleInputChange}
          />
        );
      case 'CTA':
        return (
          <ActionButton
            formData={formData}
            handleInputChange={handleInputChange}
          />
        );
      case 'GroupCTA':
        return (
          <GroupActionButton
            formData={formData}
            handleInputChange={handleInputChange}
          />
        );
      case 'Branching':
        return (
          <Branching
            formData={formData}
            handleInputChange={handleInputChange}
          />
        );
      case 'Logo':
        return (
          <Logo formData={formData} handleInputChange={handleInputChange} />
        );
      default:
        return null;
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    // Access form data using formRef
    const formData = new FormData(formRef.current);
    // Convert formData to JSON object
    const formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });

    // Log for debugging in production
    console.log('Form submitted with data:', formDataObject);

    // Update the component state with the new form data
    setFormData(formDataObject);

    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Add a small delay to ensure state is updated before updating player
    setTimeout(() => {
      if (playerRef?.current) {
        console.log('Seeking to beginning and updating player with:', formDataObject);
        playerRef.current.seekTo(0);
        playerRef.current.updatePersonalizationInfo(formDataObject);
        toast.success('Changes applied successfully!');
      } else {
        console.error('Player reference is not available');
        toast.error('Could not apply changes. Please try again.');
      }
    }, 100);
  };

  useEffect(() => {
    console.log('formData changed:', formData);
    // We don't need to update the player here since we're doing it in handleSubmit
    // This was likely causing issues in production build
  }, [formData]);

  // Add an effect to initialize the player with personalization info when it loads
  useEffect(() => {
    const initializePlayer = () => {
      if (playerRef?.current) {
        console.log('Initializing player with personalization info:', defaultPersonalizationInfo);
        try {
          playerRef.current.updatePersonalizationInfo(defaultPersonalizationInfo);
        } catch (error) {
          console.error('Error initializing player:', error);
        }
      }
    };

    // Try to initialize immediately
    initializePlayer();

    // And also set up a fallback with slight delay in case player loads after this effect
    const timeoutId = setTimeout(initializePlayer, 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  // console.log("formData", formData);

  if (!video?.tryItOut || video.tryItOut.some(value => value.trim() === '')) {
    return null;
  }

  return (
    <div className={styles.interactivityEdit}>
      <ToastContainer position="bottom-right" />
      <Form
        className={styles.personalizationForm}
        ref={formRef}
        onSubmit={handleSubmit}
      >
        <Form.Label className={styles.labelHeading}>Try it Out: </Form.Label>
        {video?.tryItOut?.map(interactivity =>
          renderFormControls(interactivity)
        )}
        <div className={styles.buttonContainer}>
          <Button className={styles.applyButton} type="submit">
            Apply
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default PersonalizationInfo;
